export default {
	 apiUrl: 'https://yes8q75cof.execute-api.us-west-2.amazonaws.com/checkout', // Production
	//apiUrl: "http://localhost:5001"
};
